import { PRESUPUESTADOR_CLEAR_OWNER_FIELDS } from './constants'

export function clearOwnerFields() {
  return {
    type: PRESUPUESTADOR_CLEAR_OWNER_FIELDS,
  }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_CLEAR_OWNER_FIELDS) {
    return {
      ...state,
      integration_car_lot_id: null,
      integration_car_lot_name: null,
      integration_branch_office_id: null,
      integration_branch_office_name: null,
    }
  } else {
    return state
  }
}
